import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  Box,
  Text,
  Flex,
  Icon,
} from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';

const ReportLimitReachedDrawer = ({ isOpen, onClose }) => {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerHeader>
            <Flex align="center">
              <Icon as={FiInfo} boxSize={6} color="teal.500" mr={2} />
              <Text fontWeight="bold">Report Limit Reached</Text>
            </Flex>
          </DrawerHeader>

          <DrawerBody>
            <Box my={4}>
              <Text>
                You have reached the maximum number of reports you can generate with your current plan. Please consider upgrading your plan to continue using our service without limitations.
              </Text>
            </Box>
          </DrawerBody>

          <DrawerFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button colorScheme="teal">Upgrade Plan</Button>
          </DrawerFooter>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default ReportLimitReachedDrawer;